export class GroupResult {
  nodeValue: number

  constructor(value: number) {
    this.nodeValue = value
  }
}
